<template>
  <div>
    <div v-if="Lib.checkPower('beauty-4-cktcxssr',2)">
      <customerTable v-if="update" ref="table" :array="table_col" :data="tableData" :change-tabs="changeTabs" :is-show-config="isShowConfig" :public-word="'套餐'" :loading="loading" :show-only-data="true" :default-sort="defaultSort" @statisticsChange="statisticsChange" @timeChange="timeChange" @searchChange="searchChange" @onCheckDetail="onCheckDetail" @onPrint="onPrint" @tableSortChange="tableSortChange" @onlyDataCheckbox="onlyDataCheckbox" />
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="currentPage" @current-change="currentChange"></el-pagination>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import api from '../../api/index.js';
import customerTable from '../others/customer_table';

export default {
  components: {
    customerTable
  },
  data() {
    return {
      timeRange: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      searchInput: '',
      tableData: [{}],
      table_col: [],
      update: true, // 刷新视图专用
      changeTabs: false, // 是否改变tabs
      isShowConfig: false, // 是否展示操作列
      total: 0,
      currentPage: 1,
      isRead: 0,
      defaultSort: {},
      sortProp: undefined,
      sortOrder: undefined,
      // 5.7
      loading: true,
      // 5.8
      statisticsRange: '1'
    };
  },
  activated() {
    this.onGetVipCardIncome(this.sortProp, this.sortOrder);
  },
  methods: {
    // 获取 套餐销售收入页面
    onGetVipCardIncome(item, SortType) {
      const vm = this;
      vm.loading = true;
      let sortObj;
      if (!item && !SortType) {
        sortObj = {
          numSort: undefined,
          moneySort: undefined
        };
      } else {
        sortObj = {
          numSort: item === 'vipCardNum' ? SortType === 'descending' ? 1 : 0 : undefined,
          moneySort: item === 'countIncome' ? SortType === 'descending' ? 1 : 0 : undefined
        };
      }
      const data = {
        beginTime: this.timeRange[0],
        endTime: this.timeRange[1],
        text: this.searchInput,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: this.currentPage,
        pageSize: 10,
        isRead: this.isRead,
        itemSort: sortObj.itemSort,
        numSort: sortObj.numSort,
        moneySort: sortObj.moneySort,
        timeCountType: this.statisticsRange
      };
      api.getVipCardIncome(data).then((res) => {
        res.data.records.forEach((x) => {
          x.itemNameList ? (x.itemNameList = x.itemNameList.join('，')) : '';
        });
        vm.tableData = res.data.records;
        vm.loading = false;
        vm.table_col = [
          {
            name: '套餐名称',
            prop: 'vipCardName',
            showTip: false,
            tip: ''
          },
          {
            name: '包含内容',
            prop: 'itemNameList',
            showTip: false,
            tip: ''
          },
          {
            name: '出售数量',
            prop: 'vipCardNum',
            showTip: false,
            tip: '',
            sortable: 'custom'
          },
          {
            name: '实收合计（元）',
            prop: 'countIncome',
            showTip: false,
            tip: '',
            sortable: 'custom'
          }
        ];
        vm.isShowConfig = true;
        vm.total = res.data.total;
        vm.defaultSort = { prop: item, order: SortType };
      });
    },
    // 统计方式改变回调
    statisticsChange(val) {
      this.statisticsRange = val;
      this.onGetVipCardIncome(this.sortProp, this.sortOrder);
    },
    // 时间改变回调
    timeChange(val) {
      this.timeRange = val;
      this.onGetVipCardIncome(this.sortProp, this.sortOrder);
    },
    // 搜索框改变回调
    searchChange(val) {
      this.searchInput = val;
      this.currentPage = 1;
      this.onGetVipCardIncome(this.sortProp, this.sortOrder);
    },
    // 查看详情
    onCheckDetail(row, time) {
      if (this.Lib.checkPower('beauty-5-cktcxssrxq') == false) return;
      this.$router.push({
        name: 'finance-detail',
        params: {
          vipCardId: row.vipCardId,
          publicWord: 'vipCard',
          name: row.vipCardName,
          date: time,
          timeCountType: this.statisticsRange
        }
      });
    },
    onPrint() {
      if (this.Lib.checkPower('beauty-4-dytcxssr') == false) return;
      const data = {
        beginTime: this.timeRange[0],
        endTime: this.timeRange[1],
        text: this.searchInput,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: 1,
        pageSize: 99999999,
        isRead: this.isRead,
        timeCountType: this.statisticsRange
      };
      api.getVipCardIncome(data).then((res) => {
        res.data.records.forEach((x) => {
          x.itemNameList = x.itemNameList.join(',');
        });
        this.$print({
          data: res.data.records,
          title: '套餐收入',
          table_tol: this.table_col

        });
      });
    },
    tableSortChange(prop, order) {
      if (this.sortProp === prop && this.sortOrder === order) {
        // this.$refs['table'].$refs['table'].clearSort()
        return;
      }
      this.sortProp = prop;
      this.sortOrder = order;

      this.onGetVipCardIncome(prop, order);
    },
    onlyDataCheckbox() {
      this.onGetVipCardIncome(this.sortProp, this.sortOrder);
    },
    currentChange() {
      this.onGetVipCardIncome(this.sortProp, this.sortOrder);
    }
  }
};
</script>

<style lang="less" scoped>
.title {
    display: flex;
}
</style>
